import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TesteService } from 'src/app/services/teste.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.scss']
})
export class CadastroComponent implements OnInit {

  fileToUpload: File | null = null;
  cpf: string;
  form: FormGroup;
  comboCursos = [];
  comboInstituicoes = [];
  comboConselhos = [];
  mensa: string;
  mcpf: string;
  mnome: string;
  mnome_civil : string;
  mgenero : string;
  mnasc: string;
  marea: string;
  mcurso: string;
  midgenero: string;
  memail: string;
  mbairro: string;
  mcidade: string;
  midinstituicao: string;
  midconselho: string;
  mnaturalidade: string;
  mnacionalidade: string;
  mendereco: string;
  mcomplemento: string;
  muf: string;
  mfixo: string;
  mcelular: string;
  mnumconselho: string;
  mdtconselho: string;
  midentidade: string;
  morgaoid: string;
  mcep: string;
  marq: string;

  mtituloeleitor: string;
  mufeleitor: string;
  mzonaeleitor: string;
  mseceleitor: string;
  mcertmilitar: string;
  morgmilitar: string;
  msecmilitar: string;
  midetinia: string;
  mgruposangue: string;
  mtiposangue: string;
  mclassificacao: string;
  mnomeac: string;
  mparenteac: string;
  mtelac: string;
  mcodturma: string;
  mbanco: string;
  magencia: string;
  mconta: string;
  mpai:string;
  mmae:string;
  mdtid: string;
  mstatus: string;
  m_cep : string;
  m_endereco: string;
  m_bairro : string;
  m_cidade : string;
  m_uf : string;

  m_numero : string;
  m_est_civil:string;
  m_passaporte : string;
  m_dt_exp_passaporte : string;
  m_dt_exp_conselho : string;


  m_filename: string;
  m_filename1: string;
  m_filename2: string;
  m_filename3: string;
  m_filename4: string;
  m_filename5: string;
  m_filename6: string;
  m_filename7: string;
  m_filename8: string;
  m_filename9: string;
  m_filename15: string;
  m_filename25: string;
  m_filename50: string;
  m_filename51: string;
  m_filename52: string;
  m_filename53: string;
  m_filename54: string;
  inscricao: any;
  existe: number;
  mostraArquvo: string;

  caminhoArquivosUpload:string;

  formData = new FormData();

  constructor( private fb: FormBuilder, private router: Router, private testeService: TesteService, private http: HttpClient) {

  }

  ngOnInit(): void {

    this.initForm();

    this.m_filename ='';
    this.m_filename1 ='';
    this.m_filename2 ='';
    this.m_filename3 ='';
    this.m_filename4 ='';
    this.m_filename5 ='';
    this.m_filename6 ='';
    this.m_filename7 ='';
    this.m_filename8 ='';
    this.m_filename9 ='';
    this.m_filename15 ='';
    this.m_filename25 ='';
    this.m_filename50 ='';
    this.m_filename51 ='';
    this.m_filename52 ='';
    this.m_filename53 ='';
    this.m_filename54 ='';


    this.cpf = this.testeService.pub_cpf;
    this.mnome = this.testeService.pub_nome;
    this.mnasc = this.testeService.pub_nasc;
    this.form.get("cpf").setValue(this.cpf);
    this.form.get("nome").setValue(this.mnome);
    this.form.get("Nasc").setValue(this.mnasc);

    this.inscricao = this.testeService.pub_inscricao;
    //console.log("+-+-+>",this.inscricao);
   // this.mnome = this.testeService.pub_inscricao.nome;
   // this.form.get("nome").setValue(this.mnome);
   //console.log("++++>"+this.mnome);
   //console.log("++-->"+this.mnasc);

   // verifica se tem arquivo e mostra, se tiver
   //IDENTIDADE
   // || (this.testeService.pubtip="1")


   //---- recarga do arquivo -----
   if (this.testeService.pubtipaux=='1'){
     this.fileMostra(this.cpf,"1");
   }

   if (this.testeService.pubtipaux=='2'){
    this.fileMostra(this.cpf,"2");
  }

  if (this.testeService.pubtipaux=='3'){
    this.fileMostra(this.cpf,"3");
  }

  if (this.testeService.pubtipaux=='4'){
    this.fileMostra(this.cpf,"4");
  }

  if (this.testeService.pubtipaux=='5'){
    this.fileMostra(this.cpf,"5");
  }

  if (this.testeService.pubtipaux=='6'){
    this.fileMostra(this.cpf,"6");
  }

  if (this.testeService.pubtipaux=='7'){
    this.fileMostra(this.cpf,"7");
  }

  if (this.testeService.pubtipaux=='8'){
    this.fileMostra(this.cpf,"8");
  }

  if (this.testeService.pubtipaux=='9'){
    this.fileMostra(this.cpf,"9");
  }

  if (this.testeService.pubtipaux=='50'){
    this.fileMostra(this.cpf,"50");
  }

  if (this.testeService.pubtipaux=='51'){
    this.fileMostra(this.cpf,"51");
  }

  if (this.testeService.pubtipaux=='52'){
    this.fileMostra(this.cpf,"52");
  }

  if (this.testeService.pubtipaux=='53'){
    this.fileMostra(this.cpf,"53");
  }

  if (this.testeService.pubtipaux=='54'){
    this.fileMostra(this.cpf,"54");
  }

  this.testeService.pubtipaux = "";


   //------------------


   this.testeService.listaDocumento('1').then((data2: any) => {
     if ((data2.id != null) || (this.testeService.pubtip=="1")) {
      this.fileMostra(this.cpf,"1");
     }
    });

  //CPF 2
  this.testeService.listaDocumento('2').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="2")) {
     this.fileMostra(this.cpf,"2");
    }
  });

  //PIS
  this.testeService.listaDocumento('3').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="3")) {
     this.fileMostra(this.cpf,"3");
    }
  });

  //COMP. RESIDENCIA
  this.testeService.listaDocumento('4').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="4")) {
     this.fileMostra(this.cpf,"4");
    }
  });

  //MILITAR
  this.testeService.listaDocumento('5').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="5")) {
     this.fileMostra(this.cpf,"5");
    }
  });

  //CONSELHO REGIONAL
  this.testeService.listaDocumento('6').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="6")) {
     this.fileMostra(this.cpf,"6");
    }
  });

  //TRANSF CONSELHO REGIONAL
  this.testeService.listaDocumento('7').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="7")) {
     this.fileMostra(this.cpf,"7");
    }
  });

  // HISTORICO
  this.testeService.listaDocumento('8').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="8")) {
     this.fileMostra(this.cpf,"8");
    }
   });

  // COMP DE EXPERIENCIA
  this.testeService.listaDocumento('9').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="9")) {
     this.fileMostra(this.cpf,"9");
    }
   });

  // DIPLOMA
  this.testeService.listaDocumento('50').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="50")) {
     this.fileMostra(this.cpf,"50");
    }
   });

  // INSS
  this.testeService.listaDocumento('51').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="51")) {
     this.fileMostra(this.cpf,"51");
    }
   });

  // QUITAÇÃO ELEITORAL
  this.testeService.listaDocumento('52').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="52")) {
     this.fileMostra(this.cpf,"52");
    }
   });

  // CTPS
  this.testeService.listaDocumento('53').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="53")) {
     this.fileMostra(this.cpf,"53");
    }
   });

  // SEG DE VIDA
  this.testeService.listaDocumento('54').then((data2: any) => {
    if ((data2.id != null) || (this.testeService.pubtip=="54")) {
     this.fileMostra(this.cpf,"54");
    }
   });

   this.testeService.listaInscricao().then((data1: any) => {
    console.log("++ D A T A 1  ******++>"+data1);

    this.mnome=data1.nome;

    this.mnome_civil=data1.nome_civil;

    this.m_numero =data1.numero;
    this.m_est_civil =data1.est_civil;
    this.m_passaporte =data1.passaporte;
    this.m_dt_exp_passaporte =data1.dt_exp_passaporte;
    this.mgenero = data1.genero;

    this.mnasc=data1.nasc;
    this.marea=data1.area;
    this.mcurso=data1.curso;
    this.mclassificacao=data1.classificacao;
    this.mcodturma=data1.codturma;
    this.midgenero=data1.idgenero;
    this.memail=data1.email;
    this.mcidade=data1.cidade;
    this.mbairro=data1.bairro;
    this.midinstituicao=data1.idinstituicao;
    this.midconselho=data1.idconselho;
    this.mnaturalidade=data1.naturalidade;
    this.mnacionalidade=data1.nacionalidade;
    this.mendereco=data1.endereco;
    this.mcomplemento=data1.complemento;
    this.muf=data1.uf;
    this.mfixo=data1.fixo;
    this.mcelular=data1.celular;
    this.mnumconselho=data1.numconselho;
    //this.mdtconselho=data1.dtconselho;
    this.midentidade=data1.identidade;
    this.morgaoid=data1.orgaoid;
    this.mdtid=data1.dtid;
    this.mcep=data1.cep;
    this.mtituloeleitor= data1.numtitulo;
    this.mufeleitor= data1.uftitulo;
    this.mzonaeleitor= data1.zonatitulo;
    this.mseceleitor= data1.secaotitulo;
    this.mcertmilitar= data1.nummilitar;
    this.morgmilitar= data1.orgmilitar;
    this.msecmilitar= data1.seriemilitar;
    this.midetinia= data1.etinia;
    this.mgruposangue= data1.grupo;
    this.mtiposangue= data1.rh;
    this.mbanco= data1.banco;
    this.magencia= data1.agencia;
    this.mconta= data1.aconta;
    this.mpai=data1.pai;
    this.mmae=data1.mae;
    this.mnomeac = data1.nomeac;
    this.mparenteac=data1.parenteac;
    this.mtelac=data1.telac;
    this.mstatus=data1.status;
    this.mconta=data1.aconta;

    console.log("+++++++****************+++++++++++-+-+> parenteac ",this.mparenteac);
    console.log("+++++++****************+++++++++++-+-+> nomeac ",this.mnomeac);
    console.log("+++++++****************+++++++++++-+-+> numconselho1 ",this.mnumconselho);

    //this.existe = this.testeService.ExisteArquivo(this.cpf,'1');
    console.log("+++++++++++++++++++-+-+> 1 ",this.testeService.ExisteArquivo(this.cpf,'1'));



    console.log('+++++++++++++++>',this.mnasc);
    console.log('....+++.....>',this.midetinia);
    console.log('....+++.....>',this.midconselho);
    console.log('....**+++**.....>',this.mnumconselho);
    this.form.get("nome").setValue(this.mnome);
    this.form.get("nome_civil").setValue(this.mnome_civil);
    this.form.get("genero").setValue('');
    this.form.get("Nasc").setValue(this.mnasc);
    this.form.get("Idarea").setValue(this.marea);
    this.form.get("Curso").setValue(this.mcurso);

   //console.log(' CCCCCC ',this.mcurso);
    this.form.get("IdSexo").setValue(this.midgenero);
    this.form.get("email").setValue(this.memail);
    this.form.get("bairro").setValue(this.mbairro);
    this.form.get("cidade").setValue(this.mcidade);
    this.form.get("IdConselho").setValue(this.midconselho);
    this.form.get("IdInstituicao").setValue(this.midinstituicao);
    this.form.get("naturalidade").setValue(this.mnaturalidade);
    this.form.get("nacionalidade").setValue(this.mnacionalidade);
    this.form.get("endereco").setValue(this.mendereco);
    this.form.get("complemento").setValue(this.mcomplemento);
    this.form.get("uf").setValue(this.muf);
    this.form.get("fixo").setValue(this.mfixo);
    this.form.get("celular").setValue(this.mcelular);
    this.form.get("numconselho").setValue(this.mnumconselho);
    this.form.get("identidade").setValue(this.midentidade);
    this.form.get("orgaoid").setValue(this.morgaoid);
    this.form.get("dtid").setValue(this.mdtid);
    this.form.get("cep").setValue(this.mcep);
    this.form.get("Numtitulo").setValue(this.mtituloeleitor);
    this.form.get("Uftitulo").setValue(this.mufeleitor);
    this.form.get("Zonatitulo").setValue(this.mzonaeleitor);
    this.form.get("Secaotitulo").setValue(this.mseceleitor);
    this.form.get("Nummilitar").setValue(this.mcertmilitar);
    this.form.get("Orgmilitar").setValue(this.morgmilitar);
    this.form.get("Seriemilitar").setValue(this.msecmilitar);
    this.form.get("Etinia").setValue(this.midetinia);
    this.form.get("Grupo").setValue(this.mgruposangue);
    this.form.get("Rh").setValue(this.mtiposangue);
    this.form.get("nomeac").setValue(this.mnomeac);
    this.form.get("parentesco").setValue(this.mparenteac);
    this.form.get("telac").setValue(this.mtelac);
    this.form.get("banco").setValue(this.mbanco);
    this.form.get("agencia").setValue(this.magencia);
    this.form.get("Aconta").setValue(this.mconta);
    this.form.get("pai").setValue(this.mpai);
    this.form.get("mae").setValue(this.mmae);
    this.form.get("status").setValue(this.mstatus);
    this.form.get("classificacao").setValue(this.mclassificacao);
    this.form.get("codturma").setValue(this.mcodturma);
    this.form.get("genero").setValue(this.mgenero);
    this.form.get("est_civil").setValue(this.m_est_civil);
    this.form.get("passaporte").setValue(this.m_passaporte);
    this.form.get("dt_exp_passaporte").setValue(this.m_dt_exp_passaporte);
    this.form.get("dt_exp_conselho").setValue(this.m_dt_exp_conselho);
    this.form.get("numero").setValue(this.m_numero);


    this.caminhoArquivosUpload= `${environment.caminhoArquivosUpload}`


    ////this.form.get("file11").setValue("this.m_filename");




  });





    this.testeService.cargaComboCursos().subscribe(resp=>{
      console.log(resp);
      this.comboCursos=resp;
    })

    this.testeService.cargaComboInstituicoes().subscribe(resp=>{
      console.log(resp);
      this.comboInstituicoes=resp;
    })


    this.testeService.cargaComboConselhos().subscribe(resp=>{
      console.log(resp);
      this.comboConselhos=resp;

    })


  }


  initForm() {
    this.form = this.fb.group({
      Curso: '',
      IdInstituicao: '',
      IdConselho: '',
      dtini: '',
      dtfim: '',
      nome: '',
      nome_civil : '',
      genero : '',
      cpf: '',
      identidade: '',
      dtid: '',
      orgaoid:'',
      Nasc: '',
      IdSexo: '',
      Idarea: '',
      Idmodalidade: '',
      nacionalidade: '',
      naturalidade: '',
      conselho: '',
      dtconselho: '',
      numconselho: '',
      cep: '',
      endereco: '',
      complemento: '',
      bairro: '',
      cidade: '',
      uf: '',
      fixo:'',
      celular: '',

      email: '',
      status: '',
      file1: '',
      file3: '',
      file5: '',
      file6: '',
      file7: '',
      file8: '',
      file9: '',
      file10: '',
      file11: '',
      file12: '',
      file13: '',
      file14: '',
      file15: '',
      file16: '',
      file17: '',
      file18: '',
      file25: '',
      file50: '',
      file51: '',
      file52: '',
      file53: '',
      file54: '',
      Rh: '',
      Grupo: '',
      Etinia: '',
      Seriemilitar: '',
      Orgmilitar:'',
      Nummilitar:'',
      Secaotitulo:'',
      Zonatitulo:'',
      Uftitulo:'',
      Numtitulo:'',
      nomeac:'',
      parentesco:'',
      telac:'',
      pai:'',
      mae:'',
      banco:'',
      agencia:'',
      Aconta:'',
      classificacao: '',
      codturma:'',
      est_civil:'',
      numero:'',
      passaporte:'',
      dt_exp_passaporte:'',
      dt_exp_conselho:'',
      sexo:''


    });
  }


  consultacep() {



        this.testeService.verificaEndereco(this.form.get('cep').value).subscribe((resp) =>
        {
          //se encontrou
          this.m_bairro = resp.bairro;
          this.m_endereco = resp.logradouro;
          this.m_cidade = resp.municipio;
          this.m_uf = resp.uf;
          this.form.get("endereco").setValue(this.m_endereco);
          this.form.get("bairro").setValue(this.m_bairro);
          this.form.get("cidade").setValue(this.m_cidade);
          this.form.get("uf").setValue(this.m_uf);      }
     , error =>
      {
        this.m_cep = '';
        this.m_bairro = '';
        this.m_endereco = '';
        this.m_cidade = '';
        this.m_uf = '';
        this.form.get("cep").setValue(this.m_cep);
        this.form.get("endereco").setValue(this.m_endereco);
        this.form.get("bairro").setValue(this.m_bairro);
        this.form.get("cidade").setValue(this.m_cidade);
        this.form.get("uf").setValue(this.m_uf);

      });

  }

  enviarInscricaoTemp() {

    this.form.controls.status.setValue('5');

    if (!this.criticaCampos())
    {
       // status pendente
       this.form.controls.status.setValue('4');
    }

      //grava inscricao
      this.testeService.incluirInscricao(this.form.value);

     //avisa inscrição concluida
      window.prompt('AVISO','Cadastro Gravado!. Realize os Uploads Necessários !');

  }



  enviarInscricao() {


    //this.testeService.incluirInscricao(this.form.value).subscribe(resp => {});
   ///this.testeService.incluirInscricao(this.form.value).subscribe(resp => {
   ///   console.log(resp);
   /// }, erro => console.error(erro));

    ///this.testeService.incluirInscricao(this.form.value);

    this.form.controls.status.setValue('5');
    this.form.controls.dtid.setValue(null);
    this.form.controls.Nasc.setValue(null);
    this.form.controls.dt_exp_conselho.setValue(null);
    this.form.controls.dt_exp_passaporte.setValue(null);


    if (!this.criticaCampos())
    {
       // status pendente
       this.form.controls.status.setValue('4');
       console.log('****>>> pendente <<<****',this.mensa);
    }
    console.log('****>>> ',this.mensa);


    if(confirm("Confirma a Gravação da Inscrição?")){
      //grava inscricao
      console.log('=====><===== ',this.form.value);

      this.testeService.incluirInscricao(this.form.value);

      if (this.form.controls.status.value=='4'){
        //avisa inscrição pedente
        window.prompt('AVISO','Inscrição PENDENTE.  Suas informações estão incompletas !');
      }else{
        //avisa inscrição concluida
        this.testeService.alteraStatus(this.testeService.pub_cpf,'5');
        window.prompt('AVISO','Inscrição COMPLETA. Aguarde email com Orientações !');
      }
    }

    // navega para a tela de login
    this.router.navigate(['/']);
  }

  get formControls() {
    return this.form.controls;
  }

  criticaCampos()
  {
    //inicializa variavel
    this.mensa ='';

    //critica nome
    if (this.form.get('nome').value==''){
      this.mensa = this.mensa +'<br> Nome em branco';
    }

    //critica cpf
    if (this.form.get('cpf').value==''){
      this.mensa = this.mensa +'<br> Cpf em branco';
    }

    //critica identidade
    if (this.form.get('identidade').value=='' || this.form.get('identidade').value==null){
      this.mensa =this.mensa +'<br> Identidade em branco';
    }

    //critica orgao Id
    if (this.form.get('orgaoid').value==''){
      this.mensa = this.mensa +'<br> Orgao Emissor em branco';
    }

    //critica Dt exp Id
    if (this.form.get('dtid').value==''){
      this.mensa = this.mensa +'<br> Data Emissão em branco';
    }

    //critica Nasc
    if (this.form.get('Nasc').value==''){
      this.mensa = this.mensa +'<br> Data Nascimento em branco';
    }

    //critica Sexo
    if (this.form.get('IdSexo').value==''){
      this.mensa = this.mensa +'<br> Sexo em branco';
    }

    //critica nacionalidade
    if (this.form.get('nacionalidade').value==''){
      this.mensa = this.mensa +'<br> Nacionalidade em branco';
    }


    //critica Naturalidade
    if (this.form.get('naturalidade').value==''){
      this.mensa = this.mensa +'<br> Naturalidade em branco';
    }

    //critica Pai
    if (this.form.get('pai').value==''){
      this.mensa = this.mensa +'<br> Nome do Pai em branco';
    }


    //critica Mãe
    if (this.form.get('mae').value==''){
      this.mensa = this.mensa +'<br> Nome da Mãe em branco';
    }

    //Tit Eleitor
    if (this.form.get('Numtitulo').value==''){
      this.mensa = this.mensa +'<br> Titulo de Eleitor em branco';
    }

   // Uf titulo
   if (this.form.get('Uftitulo').value==''){
    this.mensa = this.mensa +'<br> Uf Titulo em branco';

  }


   // zona titulo
   if (this.form.get('Zonatitulo').value==''){
    this.mensa = this.mensa +'<br> Zona do Titulo em branco';

  }

   // secao titulo
   if (this.form.get('Secaotitulo').value==''){
    this.mensa = this.mensa +'<br> Seção do Titulo em branco';

  }





    //Etinia
    if (this.form.get('Etinia').value==''){
      this.mensa = this.mensa +'<br> Etnia em branco';
    }

    //Grupo Sanguineo
    if (this.form.get('Grupo').value==''){
      this.mensa = this.mensa +'<br> Grupo Sanguineo em branco';
    }

    //Tipo sanguineo
    if (this.form.get('Rh').value==''){
      this.mensa =this.mensa +'<br> Tipo sanguineo em branco';
    }

    //Conselho profissional
    if (this.form.get('IdConselho').value==''){
      this.mensa = this.mensa +'<br> Conselho Profissional em branco';
    }

   // Cep
   if (this.form.get('cep').value==''){
    this.mensa = this.mensa +'<br> Cep em branco';

  }

    //Endereço
    if (this.form.get('endereco').value==''){
      this.mensa =this.mensa +'<br> Endereço em branco';
    }

    //numero
    if (this.form.get('numero').value==''){
      this.mensa = this.mensa +'<br> Numero do Endereco em branco';
    }

    //complemento
    if (this.form.get('complemento').value==''){
      this.mensa = this.mensa +'<br> Complemento em branco';
    }

   // Bairro
   if (this.form.get('bairro').value==''){
    this.mensa = this.mensa +'<br> Bairro em branco';

  }

   // Cidade
   if (this.form.get('cidade').value==''){
    this.mensa = this.mensa +'<br> Cidade em branco';

  }

   // Uf
   if (this.form.get('uf').value==''){
    this.mensa = this.mensa +'<br> Uf em branco';

  }

    //Email
    if (this.form.get('email').value==''){
      this.mensa = this.mensa +'<br> E-mail em branco';
    }

    // Celular
    if (this.form.get('celular').value==''){
      this.mensa = this.mensa +'<br> Celular em branco';

    }

    // ARQ IDENTIDADE
    if (this.m_filename1==''){
      this.mensa = this.mensa +'<br> Upload Identidade não realizado';

    }
    // ARQ cpf
    if (this.m_filename2==''){
      this.mensa = this.mensa +'<br> Upload CPF não realizado';

    }
    // ARQ historico
    if (this.m_filename8==''){
      this.mensa = this.mensa +'<br> Upload do Histórico não realizado';
    }

    // ARQ DIPLOMA
    if (this.m_filename50==''){
      this.mensa = this.mensa +'<br> Upload CERT. DE CONCLUSÃO não realizado';
    }

    // ARQ TIT ELEITORAL
    if (this.m_filename52==''){
      this.mensa = this.mensa +'<br> Upload COMPR. ELEITORAL não realizado';
    }


    // verifica erros
    if (this.mensa.length<4 ){
      return true;
    }else{
      window.prompt('AVISO',this.mensa);
      return false;
    }
  }




fileChange(event, tipo: string) {

    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {

      let file: File = fileList[0];


      this.m_filename = file.name;
      ///this.m_filename = '\' + this.testeService.pub_cpf + '\' + this.m_filename;
      //let formData = new FormData();
      console.log("====>"+this.m_filename);
      console.log("====> upload arq");
      this.formData.append('arquivo', file);
      this.formData.append('caminho', 'Documentos/' + this.testeService.pub_cpf);
      //this.formData.append('caminho',  this.testeService.pub_cpf);        //const url = `${environment.bancoUpload}/uploadArquivo`;

      //this.http.post( url, this.formData).subscribe(resposta => console.log('upload realizado'));

      let nome = this.m_filename;
      let extensao =  nome.substring(nome.length - 4);
      extensao = extensao.toUpperCase();
      let exte = '';


      if (extensao == ".PDF"){


          if (tipo=="1"){
            exte = this.form.get('cpf').value +  'IDE.PDF';
            this.form.get("file11").setValue(this.m_filename);
            this.m_filename1 = exte;

          }

          if (tipo=="2"){
            exte = this.form.get('cpf').value +  'CPF.PDF';
            this.form.get("file12").setValue(this.m_filename);
            this.m_filename2 = exte;

          }

          if (tipo=="3"){
            exte = this.form.get('cpf').value +  'PIS.PDF';
            this.form.get("file13").setValue(this.m_filename);
            this.m_filename3 = exte;

          }

          if (tipo=="4"){
            exte = this.form.get('cpf').value +  'RES.PDF';
            this.form.get("file14").setValue(this.m_filename);
            this.m_filename4 = exte;

          }

          if (tipo=="5"){
            exte = this.form.get('cpf').value +  'MIL.PDF';
            this.form.get("file15").setValue(this.m_filename);
            this.m_filename5 = exte;

          }

          if (tipo=="6"){
            exte = this.form.get('cpf').value +  'REG.PDF';
            this.form.get("file16").setValue(this.m_filename);
            this.m_filename6 = exte;

          }

          if (tipo=="7"){
            exte = this.form.get('cpf').value +  'TCR.PDF';
            this.form.get("file17").setValue(this.m_filename);
            this.m_filename7 = exte;

          }


          if (tipo=="8"){
            exte = this.form.get('cpf').value +  'HIS.PDF';
            this.form.get("file18").setValue(this.m_filename);
            this.m_filename8 = exte;

          }

          if (tipo=="9"){
            exte = this.form.get('cpf').value +  'EXP.PDF';
            this.form.get("file9").setValue(this.m_filename);
            this.m_filename9 = exte;

          }


          if (tipo=="50"){
            exte = this.form.get('cpf').value +  'DIP.PDF';
            this.form.get("file50").setValue(this.m_filename);
            this.m_filename50 = exte;

          }

          if (tipo=="51"){
            exte = this.form.get('cpf').value +  'INS.PDF';
            this.form.get("file51").setValue(this.m_filename);
            this.m_filename51 = exte;

          }

          if (tipo=="52"){
            exte = this.form.get('cpf').value +  'ELE.PDF';
            this.form.get("file52").setValue(this.m_filename);
            this.m_filename52 = exte;

          }

          if (tipo=="53"){
            exte = this.form.get('cpf').value +  'CTP.PDF';
            this.form.get("file53").setValue(this.m_filename);
            this.m_filename53 = exte;

          }

          if (tipo=="54"){
            exte = this.form.get('cpf').value +  'SEG.PDF';
            this.form.get("file54").setValue(this.m_filename);
            this.m_filename54 = exte;

          }

          this.formData.append('nomearquivo',  exte);

          //incluir arquivo na tabela de controle
          this.testeService.InserirArquivo(this.testeService.pub_cpf,tipo,exte).subscribe(data =>{
            console.log(data);
          }, erro => console.error(erro));

          console.log(this.formData);

          //faz o upload
          const url = `${environment.bancoUpload}/uploadArquivo`;
          this.http.post( url, this.formData).subscribe(resposta => console.log('===== >>> upload realizado'));



      }else{
        window.prompt('AVISO','SOMENTE ARQUIVOS FORMATO PDF SÃO PERMITIDOS !');
      }
    }
}


fileTrans(tipo: string) {

      //incluir arquivo na tabela de controle
      this.testeService.InserirArquivo(this.testeService.pub_cpf,tipo,this.m_filename).subscribe(data =>{
        console.log(data);
      }, erro => console.error(erro));

      console.log(this.testeService.pub_cpf,tipo,this.m_filename);


      if (tipo=="1"){
        this.form.get("file11").setValue(this.m_filename);
      }

      if (tipo=="2"){
        this.form.get("file12").setValue(this.m_filename);
      }

      if (tipo=="3"){
        this.form.get("file13").setValue(this.m_filename);
      }

      if (tipo=="4"){
        this.form.get("file14").setValue(this.m_filename);
      }

      if (tipo=="5"){
        this.form.get("file15").setValue(this.m_filename);
      }

      if (tipo=="6"){
        this.form.get("file16").setValue(this.m_filename);
      }

      if (tipo=="7"){
        this.form.get("file17").setValue(this.m_filename);
      }

      if (tipo=="8"){
        this.form.get("file18").setValue(this.m_filename);
      }

      if (tipo=="9"){
        this.form.get("file9").setValue(this.m_filename);
      }

      if (tipo=="15"){
        this.form.get("file25").setValue(this.m_filename);
      }

      if (tipo=="50"){
        this.form.get("file50").setValue(this.m_filename);
      }

      if (tipo=="51"){
        this.form.get("file51").setValue(this.m_filename);
      }

      if (tipo=="52"){
        this.form.get("file52").setValue(this.m_filename);
      }

      if (tipo=="53"){
        this.form.get("file53").setValue(this.m_filename);
      }

      if (tipo=="54"){
        this.form.get("file54").setValue(this.m_filename);
      }

      //faz o upload
      const url = `${environment.bancoUpload}/uploadArquivo`;
      this.http.post( url, this.formData, ).subscribe(resposta => console.log('upload realizado'));


}

visualiza(arquivo: string){

  this.testeService.testePdf("Ata Reunião.docx");

}

fileDelete(id: string, caminho: string, arquivo: string) {

//excluir arquivo na tabela de controle
console.log("delete----"+this.testeService.pub_cpf+"---"+id);

this.testeService.DeletarArquivo(this.testeService.pub_cpf,id).subscribe(data =>{
  console.log(data);
}, erro => console.error(erro));


console.log("delete-"+id)
if (id=="1"){
  this.form.get("file11").setValue('');
  this.m_filename1='';
}

if (id=="2"){
  this.form.get("file12").setValue('');
  this.m_filename2='';
}

if (id=="3"){
  this.form.get("file13").setValue('');
  this.m_filename3='';
}

if (id=="4"){
  this.form.get("file14").setValue('');
  this.m_filename4='';
}

if (id=="5"){
  this.form.get("file15").setValue('');
  this.m_filename5='';
}

if (id=="6"){
  this.form.get("file16").setValue('');
  this.m_filename6='';
}

if (id=="7"){
  this.form.get("file17").setValue('');
  this.m_filename7='';
}


if (id=="8"){
  this.form.get("file18").setValue('');
  this.m_filename8='';
}

if (id=="9"){
  this.form.get("file9").setValue('');
  this.m_filename9='';
}

if (id=="50"){
  this.form.get("file50").setValue('');
  this.m_filename50='';
}

if (id=="51"){
  this.form.get("file51").setValue('');
  this.m_filename51='';
}

if (id=="52"){
  this.form.get("file52").setValue('');
  this.m_filename52='';
}

if (id=="53"){
  this.form.get("file53").setValue('');
  this.m_filename53='';
}

if (id=="54"){
  this.form.get("file54").setValue('');
  this.m_filename54='';
}

//Apaga arquivo
const url = `${environment.bancoUpload}/DeleteArquivo`;
//caminho +
this.formData.append('caminho', 'DOCUMENTOS/' + this.testeService.pub_cpf +'/');
this.formData.append('nomearquivo', arquivo);
this.http.post( url,this.formData , ).subscribe(resposta => console.log('Arquivo apagado'));

this.m_filename="";

}

//---------------------------

fileUp(id: string, caminho: string, arquivo: string) {

  this.testeService.pubtipaux="";

  //salva dados cadastrais
  this.form.controls.status.setValue('4');
  this.form.controls.dtid.setValue(null);
  this.form.controls.Nasc.setValue(null);
  this.form.controls.dt_exp_conselho.setValue(null);
  this.form.controls.dt_exp_passaporte.setValue(null);
  this.testeService.incluirInscricao(this.form.value);

  // navega para a tela de upload
  this.testeService.pubtip = id;

  this.router.navigate(['/upload']);
  this.form.get("file1").setValue(this.testeService.pubdoc);

}

//---------------------------

fileMostra(cpf: string, id: string) {

  if (id=="1"){
    this.marq=cpf+'IDE.PDF';
    this.form.get("file11").setValue(this.marq);
    this.m_filename1=this.marq;
  }

  if (id=="2"){
    this.marq=cpf+'CPF.PDF';
    this.form.get("file12").setValue(this.marq);
    this.m_filename2=this.marq;

  }

  if (id=="3"){
    this.marq=cpf+'PIS.PDF';
    this.form.get("file13").setValue(this.marq);
    this.m_filename3=this.marq;

  }

  if (id=="4"){
    this.marq=cpf+'RES.PDF';
    this.form.get("file14").setValue(this.marq);
    this.m_filename4=this.marq;
  }

  if (id=="5"){
    this.marq=cpf+'MIL.PDF';
    this.form.get("file15").setValue(this.marq);
    this.m_filename5=this.marq;
  }

  if (id=="6"){
    this.marq=cpf+'REG.PDF';
    this.form.get("file16").setValue(this.marq);
    this.m_filename6=this.marq;
  }

  if (id=="7"){
    this.marq=cpf+'TCR.PDF';
    this.form.get("file17").setValue(this.marq);
    this.m_filename7=this.marq;
  }



  if (id=="8"){
    this.marq=cpf+'HIS.PDF';
    this.form.get("file18").setValue(this.marq);
    this.m_filename8=this.marq;
  }



  if (id=="9"){
    this.marq=cpf+'EXP.PDF';
    this.form.get("file9").setValue(this.marq);
    this.m_filename9=this.marq;
  }


  if (id=="50"){
    this.marq=cpf+'DIP.PDF';
    this.form.get("file50").setValue(this.marq);
    this.m_filename50=this.marq;
  }

  if (id=="51"){
    this.marq=cpf+'INS.PDF';
    this.form.get("file51").setValue(this.marq);
    this.m_filename51=this.marq;
  }

  if (id=="52"){
    this.marq=cpf+'ELE.PDF';
    this.form.get("file52").setValue(this.marq);
    this.m_filename52=this.marq;
  }

  if (id=="53"){
    this.marq=cpf+'CTP.PDF';
    this.form.get("file53").setValue(this.marq);
    this.m_filename53=this.marq;
  }

  if (id=="54"){
    this.marq=cpf+'SEG.PDF';
    this.form.get("file54").setValue(this.marq);
    this.m_filename54=this.marq;
  }

  this.m_filename="";
  }








//-----------------------------






retorna(){

  this.form.controls.status.setValue('5');

  if (!this.criticaCampos())
  {
     // status pendente
     this.form.controls.status.setValue('4');

  }

  if (this.form.controls.status.value=='4'){
      //avisa inscrição pedente
      window.prompt('AVISO','Inscrição PENDENTE.  Suas informações estão incompletas !');
  }else{
      //avisa inscrição concluida
      window.prompt('AVISO','Inscrição COMPLETA. Aguarde email com Orientações !');
  }


  // navega para a tela de login
  this.router.navigate(['/']);

}


}


